// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    SquareChevronDown,
    SquareChevronLeft,
    SquareChevronRight,
    SquareChevronUp,
    SquareCode,
    SquareDashed,
    SquareDashedBottom,
    SquareDashedBottomCode,
    SquareDashedKanban,
    SquareDashedMousePointer,
    SquareDashedText,
    SquareDashedTopSolid,
    SquareDimensions,
    SquareDivide,
    SquareDot,
    SquareEqual,
    SquareExclamationPoint,
    SquareFunction,
    SquareKanban,
    SquareLibrary,
    SquareM,
    SquareMenu,
    SquareMinus,
    SquareMousePointer,
    SquareOff,
    SquareParking,
    SquareParkingOff,
    SquarePause,
    SquarePen,
    SquarePercent,
    SquarePi,
    SquarePilcrow,
    SquarePlay,
    SquarePlus,
    SquarePower,
    SquareRadical,
    SquareRoundCorner,
    SquareScissors,
    SquareSigma,
    SquareSlash,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "square-chevron-down" through "square-slash", inclusive. */
const shard: Record<string, LucideIcon> = {
    "square-chevron-down": SquareChevronDown,
    "square-chevron-left": SquareChevronLeft,
    "square-chevron-right": SquareChevronRight,
    "square-chevron-up": SquareChevronUp,
    "square-code": SquareCode,
    "square-dashed": SquareDashed,
    "square-dashed-bottom": SquareDashedBottom,
    "square-dashed-bottom-code": SquareDashedBottomCode,
    "square-dashed-kanban": SquareDashedKanban,
    "square-dashed-mouse-pointer": SquareDashedMousePointer,
    "square-dashed-text": SquareDashedText,
    "square-dashed-top-solid": SquareDashedTopSolid,
    "square-dimensions": SquareDimensions,
    "square-divide": SquareDivide,
    "square-dot": SquareDot,
    "square-equal": SquareEqual,
    "square-exclamation-point": SquareExclamationPoint,
    "square-function": SquareFunction,
    "square-kanban": SquareKanban,
    "square-library": SquareLibrary,
    "square-m": SquareM,
    "square-menu": SquareMenu,
    "square-minus": SquareMinus,
    "square-mouse-pointer": SquareMousePointer,
    "square-off": SquareOff,
    "square-parking": SquareParking,
    "square-parking-off": SquareParkingOff,
    "square-pause": SquarePause,
    "square-pen": SquarePen,
    "square-percent": SquarePercent,
    "square-pi": SquarePi,
    "square-pilcrow": SquarePilcrow,
    "square-play": SquarePlay,
    "square-plus": SquarePlus,
    "square-power": SquarePower,
    "square-radical": SquareRadical,
    "square-round-corner": SquareRoundCorner,
    "square-scissors": SquareScissors,
    "square-sigma": SquareSigma,
    "square-slash": SquareSlash,
};

export default shard;
